const previewSample = require('./utility/previewSample.js')
const playSample = require('./utility/playSample.js')
const stopLoop = require('./utility/stopLoop.js')

module.exports = function (state, emitter) {
  state.draggingSampleOnBoard = null
  emitter.on('play-next-sound', () => {
    console.log("play-next-sound")
    state.keyIsDown = true
    // const sampleIndex = state.boardLayout.findIndex(s => s.key === key)
    let sampleIndex = state.nextSampleIndex
    if (
      sampleIndex !== -1
      && state.activeButtons.indexOf(sampleIndex) === -1
    ) {
      if (state.selectedSample) {
        // place sample
        emit('placesample', sampleIndex)
      } else {
        // play sample
        const sample = state.samples.find(
          s => s.id === state.sampleBoard[sampleIndex]
        )
        emitter.emit('stopallsounds')
        playSample(sample)
        console.log("playing sample", sample, sample.file.state)
        emitter.emit('triggerbutton', sampleIndex)
        emitter.emit('render')
      }
    }
  })

  emitter.on('previewsample', (sampleId) => {
    console.log('previewsample')
    let sample = state.samples.find(s => s.id === sampleId)
    previewSample(sample)
    emitter.emit('unfocus')
  })

  emitter.on('playsample', (sampleId) => {
    emitter.emit('stopallsounds')
    console.log('playsample')
    let sample = state.samples.find(s => s.id === sampleId)
    playSample(sample)
    emitter.emit('unfocus')
  })

  emitter.on('stoploop', (sampleId) => {
    console.log('stoploop')
    let sample = state.samples.find(s => s.id === sampleId)
    stopLoop(sample)
    emitter.emit('unfocus')
  })

  emitter.on('stopallsounds', () => {
    console.log('stopallsounds')
    Object.values(state.samples).forEach(s => s.file.stop())
    if (state.recordedSample) {
      state.recordedSample.stop()
    }
    emitter.emit('unfocus')
  })

  emitter.on('select-sample-from-board', (sampleId) => {
    console.log('select-sample-from-board', sampleId)
    state.draggingSampleOnBoard = sampleId
    function onMouseUp() {
      emitter.emit('drop-sample-on-board')
    }
    document.addEventListener('mouseup', onMouseUp)
    emitter.emit('render')
  })

  emitter.on('drop-sample-on-board', () => {
    console.log('drop-sample-on-board')
    state.draggingSampleOnBoard = null
    emitter.emit('render')
  })

  emitter.on('drag-sample-over-board', index => {
    console.log("drag-sample-over-board", index)
    const draggingSampleId = state.sampleBoard[state.draggingSampleOnBoard]
    const hoverSampleId  = state.sampleBoard[index]
    state.sampleBoard[state.draggingSampleOnBoard] = hoverSampleId
    state.sampleBoard[index] = draggingSampleId
    state.draggingSampleOnBoard = index
    emitter.emit('render')
    
  })
}
